import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import style from './BoardItem.css';
import LiveItem from "./LiveItem";

const PostItem = ({post}) => {
}

const DailyItem =({post}) => {
  return <div className={style.daily_board}>
    <h4 className={style.daily_title}>
      <a href={`/p/${post.id}`}>
        {post.title}
      </a>
    </h4>
    <p className={style.daily_summary}>
      {post.summary && post.summary.substr(0, 240)}
    </p>
  </div>
}

export default class BoardItem extends PureComponent {
  propTypes = {
    board: PropTypes.object.isRequired,
  }


  render() {
    let {board: {type, object}} = this.props;

    if (type === 'live') {
      return <LiveItem live={object}/>

    } else if (type === 'post' && /(日报.*)?\d+\/\d+\/\d+(.*日报)?/.test(object.title)){
      return <DailyItem post={object} />
    }

    return (
        <div className={style.board}>
        </div>
    )
  }
}
